import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import { shouldShowFolderPane } from './shouldShowFolderPane';
import { shouldShowFolderPaneAsOverlay } from './shouldShowFolderPaneAsOverlay';

export function shouldShowFavoritesSideRail(): boolean {
    return (
        isGlobalFeatureEnabled('fp-vertical-favorites') &&
        (!shouldShowFolderPane() || shouldShowFolderPaneAsOverlay())
    );
}
